import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectCountries } from '../selectors/app'

export const useCountryCode = (countryName: string) => {
  const countries = useSelector(selectCountries, (prev, next) => prev.length === next.length)
  const countryData = useMemo(
    () => countries.find((country) => country.name === countryName),
    [countries, countryName]
  )

  if (countryData) {
    return countryData.value
  }

  return ''
}
